import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/animations';

export default function Section({ id, eyebrow, title, subtitle, children }) {
  return (
    <section id={id} className="relative px-6 py-20 md:px-10 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
          className="mb-10 max-w-3xl"
        >
          <div className="mb-4 inline-flex items-center rounded-full border border-white/15 bg-white/5 px-4 py-1 text-xs uppercase tracking-[0.28em] text-blue-100/80">
            {eyebrow}
          </div>
          <h2 className="text-3xl font-semibold tracking-tight text-white md:text-5xl">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-4 max-w-2xl text-base leading-7 text-white/70 md:text-lg">
              {subtitle}
            </p>
          )}
        </motion.div>
        {children}
      </div>
    </section>
  );
}